var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"type":"number","value":_vm.value,"step":"any","placeholder":"0.00","no-wheel":""},on:{"input":_vm.convertToNumber}})}
var staticRenderFns = []

export { render, staticRenderFns }